












import Vue from 'vue'
export default Vue.extend({
  computed: {
    oneRect() {
      return `rect(0px, ${this.size}, ${this.size}, calc(${this.size} / 2))`
    },
    otherRect() {
      return `rect(0px, calc(${this.size} / 2), ${this.size}, 0px)`
    },
    rotate() {
      const progress: number = this.value ? (this.value as number) : 0
      return `rotate(${progress * 1.8}deg)`
    },
  },
  props: {
    label: {
      type: String,
    },
    color: {
      type: String,
    },
    trackColor: {
      type: String,
    },
    size: {
      type: String,
      default: '100px',
    },
    value: {
      type: Number,
      validator: value => {
        return value >= 0 || value <= 100
      },
    },
  },
})
